import React from "react";
import styled from "styled-components";

const Style = styled.div`
    display: flex;
    flex-direction: column;
    position: relative;
    .title {
        font-size: 1.5rem;
        font-weight: 800;
        margin: 1rem 0 0.5rem;
        :first-child {
            margin: 0 0 0.5rem;
        }
    }
    .paragraph {
        margin: 0.25rem 0;
        font-size: 1rem;
        text-align: justify;
    }
    .space {
        margin: 0.5rem 0;
    }
    .btn {
        margin: 0.5rem 0;
        cursor: pointer;
        flex-grow: 1;
        border-radius: 8px;
        font-size: 1.2rem;
        font-weight: 600;
        text-align: center;
        padding: 0.75rem 1rem 0.8rem;
        color: var(--fsc-d-1);
        text-decoration: none;
        border: 1px solid var(--prime-2);
        width: min-content;
        white-space: nowrap;
    }
    @media (max-width: 850px){
        .btn {
            width: auto;
            padding: 0.75rem 0.2rem 0.8rem;
        }
    }
`;

export default function TextRenderer({data}) {
    const makeText = (text) => {
        return text.map((val, key) => {
            switch (val.type) {
                case "title":
                    return (
                        <div className="title">
                            {val.text}
                        </div>
                    );
                case "paragraph":
                    return (
                        <div className="paragraph">
                            {val.text}
                        </div>
                    );
                case "space":
                    return (
                        <div className="space">
                        </div>
                    );
                case "items":
                    return val.text.map((val2, id) => {
                        return (
                            <div className="paragraph" key={id}>
                                {val2}
                            </div>
                        )
                    })
                case "btn":
                    return (
                        <a href={val.link} target={"_blank"} className="btn">
                            {val.text}
                        </a>
                    );
                default:
                    return "";
            }
        })
    }
    return (
      <Style>
        {makeText(data)}
      </Style>
  );
}
